export default "__VITE_ASSET__deFDhtpD__"